import React from "react";
import { FaLinkedin, FaLine } from "react-icons/fa";
import { SiTelegram } from "react-icons/si";

function Footer() {
  return (
    <>
      <div className="h-40 md:h-4 md:mt-16">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#F8C8DC"
            fill-opacity="1"
            d="M0,160L60,149.3C120,139,240,117,360,117.3C480,117,600,139,720,128C840,117,960,75,1080,58.7C1200,43,1320,53,1380,58.7L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          ></path>
        </svg>
      </div>
      <div className="bg-theme w-screen flex justify-center">
        <div className="md:w-full w-1/2">
          <div className="bg-theme p-10 font-mont text-center"></div>

          <div className="h-1 border-2 border-themedk border-dotted"></div>
          <div className="flex text-themedk w-full justify-between py-3 md:px-10">
            <a href="https://t.me/dearberry" target="blank">
              <SiTelegram size={30} />
            </a>
            <a href="https://www.linkedin.com/in/dearberry/" target="blank">
              <FaLinkedin size={30} />
            </a>
            <a href="https://line.me/ti/p/M6DQ2C-f1V" target="blank">
              <FaLine size={30} />
            </a>
          </div>
          <div className="h-1 border-2 border-themedk border-dotted mb-10"></div>
        </div>
      </div>
    </>
  );
}

export default Footer;
